import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { LinkVariant } from 'mdi-material-ui';
import FileIcon from '../FileIcon';
import SharedTypography from '../Typography';
const FileShow = ({ plan, file }) => {
    return (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [plan.url && file.name === plan.url ? (_jsx(LinkVariant, { sx: {
                    width: 16,
                    height: 16,
                } })) : (_jsx(FileIcon, { filename: file.name, fontSize: "small" })), _jsx("a", Object.assign({ href: file.url, target: "_blank", style: {
                    textDecoration: 'none',
                    width: '100%',
                    overflow: 'hidden',
                } }, { children: _jsx(SharedTypography, Object.assign({ variant: "body2", color: "text.dark", sx: {
                        fontSize: '13px',
                        whiteSpace: 'nowrap',
                        width: '80%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: 'block',
                    }, clamp: 2 }, { children: file.name })) }))] })));
};
export default FileShow;
